import { ShieldCheck } from 'lucide-react';

import { DashboardLayout } from '@/components/dashboard/DashboardLayout';
import { PageHeader } from '@/components/dashboard/PageHeader';
import { StatusBadge } from '@/components/dashboard/StatusBadge';
import { campaigns } from '@/lib/mockData';

const HotesseProfil = () => (
  <DashboardLayout
    role="hotesse"
    user={{ name: 'Anike Aya', subtitle: 'Hôtesse Admin', initials: 'AA' }}
  >
    <PageHeader title="Mon profil" subtitle="Compte hôtesse — créé par Super Admin Winkô." />

    <div className="grid gap-6 lg:grid-cols-[1fr_1.6fr]">
      <div className="rounded-2xl border border-border bg-card p-6 shadow-soft">
        <div className="flex items-center gap-4">
          <div className="grid size-16 place-items-center rounded-2xl bg-gradient-primary font-display text-xl font-bold text-primary-foreground shadow-cta">
            AA
          </div>
          <div>
            <h2 className="font-display text-xl font-bold">Anike Aya</h2>
            <p className="text-sm text-muted-foreground">Anike_agentB</p>
          </div>
        </div>
        <div className="mt-5 inline-flex items-center gap-2 rounded-full border border-primary/20 bg-primary/10 px-3 py-1 text-xs font-semibold text-primary">
          <ShieldCheck className="size-3.5" />
          Niveau Admin
        </div>
        <dl className="mt-6 space-y-3 text-sm">
          <div className="flex justify-between">
            <dt className="text-muted-foreground">Identifiant</dt>
            <dd className="font-medium">Anike_agentB</dd>
          </div>
          <div className="flex justify-between">
            <dt className="text-muted-foreground">Ville</dt>
            <dd className="font-medium">Abidjan</dd>
          </div>
          <div className="flex justify-between">
            <dt className="text-muted-foreground">Membre depuis</dt>
            <dd className="font-medium">Janv. 2026</dd>
          </div>
        </dl>
      </div>

      <div className="rounded-2xl border border-border bg-card p-6 shadow-soft">
        <h3 className="font-display text-lg font-bold">Campagnes assignées</h3>
        <p className="text-xs text-muted-foreground">Activations en cours et passées.</p>
        <ul className="mt-4 divide-y divide-border">
          {campaigns
            .filter(c => c.status !== 'review' && c.status !== 'draft')
            .slice(0, 4)
            .map(c => (
              <li key={c.id} className="flex items-center justify-between gap-3 py-3">
                <div className="min-w-0">
                  <p className="truncate font-semibold">{c.name}</p>
                  <p className="text-xs text-muted-foreground">
                    {c.brand} • {c.city}
                  </p>
                </div>
                <StatusBadge status={c.status} />
              </li>
            ))}
        </ul>
      </div>
    </div>
  </DashboardLayout>
);

export default HotesseProfil;
